import { render } from "./hotelReservation.vue?vue&type=template&id=bcbd7e46"
import script from "./hotelReservation.vue?vue&type=script&lang=js"
export * from "./hotelReservation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__